
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 30 25.3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","d":"M0 0h28"}}),_c('path',{attrs:{"d":"M0 23.3h30v2H0zm15.4-5v-2a2.946 2.946 0 01-3-3h-2a5.081 5.081 0 005 5z"}}),_c('path',{attrs:{"d":"M15 21.9a8.024 8.024 0 008-8 11.074 11.074 0 00-1.3-4A42.548 42.548 0 0019 5.3c-1.4-2-2.4-3.3-3-4L15 0l-1 1.2a39.309 39.309 0 00-3 4 43.912 43.912 0 00-2.7 4.7 11.074 11.074 0 00-1.3 4 8.024 8.024 0 008 8zm-5-11.1a39.075 39.075 0 012.6-4.4A32.458 32.458 0 0115 3.2c.6.7 1.4 1.8 2.4 3.2a39.075 39.075 0 012.6 4.4 8.568 8.568 0 011 3.2 6 6 0 01-12 0 8.568 8.568 0 011-3.2z"}})])
          )
        }
      }
    